import React from 'react';
import { useQuery } from 'react-fetching-library';
import { getAgreementDynamicSections } from '../../../services/request';
import DynamicSectionsList from './DynamicSectionsList';

export const DynamicSections = () => {
  const [dynamicSections, setDynamicSections] = React.useState([]);
  const [search, setSearch] = React.useState(null);
  const { loading, payload, error } = useQuery(getAgreementDynamicSections('GET', search));

  const queryCallback = (searchVal = null) => {
    setSearch(searchVal);
  };

  React.useEffect(() => {
    if (!loading && !error) {
      setDynamicSections(payload.results);
    }
  }, [loading]);
  console.log('rows', payload);


  return (
    <>
      <DynamicSectionsList dynamicSections={dynamicSections} queryCallback={queryCallback} setDynamicSections={setDynamicSections}/>
    </>

  );
};
